import './footer.sass';

export { default } from './footer';
